export default {
    Home:{
        homeTit:'Welcome to the backend management system',
        leftMenu:'Please select from the left menu',
        governlogon:"Administrator Login",
        logon:"log on",
        NOReLogin:"Login has expired, do I need to log in again?",
        ReLogin:"Re login",
        NOLogin:'Cancel login',
        overtime:"Request timed out, please try again later",
        networkError:"Network error, please check your network connection",
        noResponse:"The server is not responding, please try again later",
        CCKTiTle:"CCK Unified Portal"
    },
    Menu:{
        homePage:'Home',
        userManagement:'User Management',
        userList:'User List',
        addAUser:' Add User',
        clientManagement:'Client Management',
        clientList:'Client Management',
        addingAClient:'Add Client',
        authorityManagement:'Role Management',
        administratorList:'Admin List',
        addAnAdministrator:'Add Admin',
        work:"Online office",
        staff:"Employee APP",
        client:"Customer APP",
        // settings:"System settings",

    },
    Button:{
        inquire:'Query',
        changePassword:'Change Password',
        modifyInformation:'Modify information',
        forbidden:'Disable',
        recover:'Restore',
        previous:'Previous Page',
        nextPage:'Next Page',
        cancel:'Cancel',
        submit:"Submit",
        normal:'Normal',
        unknownState:'Unknown state',
        verify:'Confirm',
        save:'Save',
        reset:'Reset',
        displayKey:'Display key',
        englishTemplate:"English Template",
        vietnameseTemplates:"Vietnamese Template",
        chineseTemplate:'Chinese Template',
        English:"English",
        Chinese:'Chinese',
        Vietnamese:'Vietnamese',
        VN:"Vietnam",
        Thai:"Thai",
        Copy:"copy",
        nameTube:'Domain name management',
        phoneCode:'Mobile verification code',
        emailCode:'Email verification code',
        infoCode:'Information verification',
        no:'NO',
        is:'YES',
        LogOut:"Log Out",
        OAOffice:'OA office',
        download:"Download",
        sailSoft:"Sail Soft"
    },
    Tips:{
        pleaseEnterQueryContent:"Please enter the query content",
        noDataAvailable:'No data available at the moment',
        warmReminder:'Tips',
        pleaseEnterPassword:'Please input a password',
        passwordLengthIsTooShort:'Password length cannot be less than six digits',
        passwordStatusError:"The password and confirmation password do not match. Please re-enter",
        pleaseConfirmPassword:'Please confirm password',
        passwordChangedSuccessfully:'Please confirm password',
        mobilePhoneFormatError:'The format of the phone number is incorrect',
        enterUsername:'enter one user name',
        userNameLengthLimit:"The username length is between 3 and 20 characters",
        enterMobileNumber:'Please enter your phone number',
        enterEmailAddress:'Please enter your email address',
        emailAddressError:'The email address format is incorrect',
        enterIdNumber:'Please enter ID number number',
        idNumberError:'The format of ID number is incorrect',
        enterUserAddress:'Please enter the user address',
        userHasReEntered:'The user already exists, please re-enter',
        submitSuccessfully:"Submitted successfully!",
        requestTimeout:"Request timeout",
        TetxdisableUser1:'Are you sure you want to ',
        TetxdisableUser2:'the user?',
        stateChange:"successfully!",
        inputUserApp:'Please enter the app to which the user belongs',
        userAppLengthLimit:"The length of the user's app is between 6 and 8 characters",
        inputuserID:'Please enter user ID',
        userIdLengthLimit:'The length of the user ID is between 5 and 10 characters',
        enterUserPassword:'Please enter the user password',
        UserPasswordLengthLimit:'The user password length is between 3 and 10 characters',
        enterUserSource:'Please enter user source',
        UserSourceLengthLimit:'The length of the user source is between 3 and 10 characters',
        enterUserRole:"Please enter the user role",
        saveComplete:'Save completed!',
        enterCustomerName:'Please enter the customer name',
        CustomerNameLengthLimit:"The customer name cannot be less than 2 characters",
        selectLoginTemplate:'Please select a login template',
        pleaseSelectLoginTemplate:"You haven't selected a login template yet",
        selectLanguage:'please select language',
        noChoiceLanguage:"You haven't selected a language yet",
        submissionCompleted:"Information submission completed!",
        undeveloped:'Not yet developed',
        copySuccess:"Replicating Success",
        nocopy:"Copy failed, please manually copy",
        pleaseSelect:"Please select",
        inputValidJSON:'Please enter a valid JSON format',
        inputSystem:'Please enter the docking system ID',
        stytemLengthLimit:'The length of the docking system ID is between 5 and 8 characters',
        InputSystemLogo:'Please enter the logo of the docking system',
        enterLoginYseLink:"Please enter the link after successful login",
        enterSystemSubsystemLink:'Please enter multiple subsystem links for the docking system',
        enterSystemBackLink:'Please enter the link returned by the system',
        chooseForgetVerify:'Please choose the verification method for forgotten password',
        atLeastOneOption:'Please select at least one option',
        customerExistsToReEnter:'The client already exists. Please re-enter',
        accountPasswordError:"Account or password incorrect, please re-enter",
        inputAppID:"Please enter the application ID",
        AppIDLengthLimit:"The length of the user's app is between 6 and 9 characters"
    },
    form:{
        userID:"user Id",
        username:"user name",
        cellphone:"phone number",
        IDcard:"ID card",
        status:"state",
        updateTime:"update time",
        controls:'operate',
        cipher:"password",
        resetpwd:"reset password",
        userAddress:"User address",
        userApp:"User's app",
        userName:'User Name',
        userpwd:'Password',
        userPhone:"User's mobile phone number",
        userEmail:'User Mailbox',
        userSource:'User source',
        userRole:'User Role',
        ordinaryUser:'Ordinary users',
        userVip:'Ordinary administrator',
        userVips:'Super administrator',
        appID:'client ID',
        Customer:'Customer',
        secretKey:"secret key",
        loginTemplate:'Login Template',
        language:'language',
        dockingSystemID:"ID of the docking system",
        systemName:"Name of the docking system",
        frontEndSystemTemplate:"Front end template for docking system",
        systematicLogo:"Logo of the docking system",
        loginJumpLink:"Successful login redirect link",
        subsystemOfSystemURL:"URLs for multiple subsystems of the docking system",
        backToSystemLink:"Return the link to the docking system",
        dockingSystemLanguage:"The national language of the docking system",
        psdAuthentication:"Forgot password verification method",
        openEnrollmentOrNot:"Is registration open",
        loginFailureSkipRegistration:"Do login failures redirect to registration",
        Role:'Role',
        applyID:"APP ID"
    }
}
